export const DAY_OF_WEEK_COLUMN_TITLE_ID = 'day-of-week-column-title';
